import Vue from 'vue'
import Router from 'vue-router'
import MenuListPage from '@/pages/MenuListPage.vue'
import DesignPage from '@/pages/DesignPage.vue'
import MenuTopPage from '@/pages/MenuTopPage.vue'
import ItemManagementPage from '@/pages/ItemManagementPage.vue'
import ScheduleEditPage from '@/pages/ScheduleEditPage.vue'
import DEBUG_PAGE from "@/pages/DEBUG_PAGE.vue";
import UserStore from "@/store/modules/UserStore";
import {Util} from "@/_global/utils";
import ScheduleCreatePage from "@/pages/ScheduleCreatePage.vue";
import PreviewPage from '@/pages/PreviewPage.vue'

Vue.use(Router);

const router = new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'root',
            redirect: '/menus'
        },
        {
            path: '/menus',
            name: 'menu_list',
            component: MenuListPage,
        },
        {
            path: '/menu/:menuId',
            name: 'menu_top',
            component: MenuTopPage,
        },
        {
            path: '/menu/:menuId/schedule/new',
            name: 'menu_schedule_create',
            component: ScheduleCreatePage,
        },
        {
            path: '/menu/:menuId/schedule/:scheduleId',
            name: 'menu_schedule_edit',
            component: ScheduleEditPage,
        },
        {
            path: '/menu/:menuId/design',
            name: 'menu_design_nav',
            component: DesignPage,
        },
        {
            path: '/menu/:menuId/design/page/:pageName',
            name: 'menu_page_design',
            component: DesignPage,
        },
        {
            path: '/menu/:menuId/sales/category/:categoryId/',
            name: 'menu_item',
            component: ItemManagementPage,
        },
        {
            path: '/menu/:menuId/sales/category/:categoryId/item/:itemId',
            name: 'menu_item_detail',
            component: ItemManagementPage,
        },
        {
            path: '/menu/:menuId/preview',
            name: 'preview',
            component: PreviewPage,
        },
        {
            path: '/debug',
            name: 'debug',
            component: DEBUG_PAGE,
        },
    ],
    scrollBehavior (to, from, savedPosition) {
        // 画面遷移時、スクロール位置をリセットする
        return { x: 0, y: 0 }
    }
});


// ログインチェック
router.beforeEach(async (to, from, next) => {
    await UserStore.update();
    if (UserStore.isAuthenticated) {
        next();
    } else {
        location.href = Util.deliouTopPageUrl();
    }
});


export default router;
